import apiService from "./ApiService"
import { createQS } from "./Utils"

export const StatusComponenteEnum = {
  INSTALADO: 'instalado',
  AGUARDANDO_DEFINICAO: 'aguardando_definicao',
  ESTOQUE: 'estoque',
  EM_MANUTENCAO: 'em_manutencao',
  AGUARDANDO_DESCARTE: 'aguardando_descarte',
  DESCARTADO: 'descartado'
}

export function statusComponenteText(status) {
  switch (status) {
    case StatusComponenteEnum.INSTALADO:
      return 'Instalado'
    case StatusComponenteEnum.AGUARDANDO_DEFINICAO:
      return 'Aguardando definição'
    case StatusComponenteEnum.ESTOQUE:
      return 'Estoque'
    case StatusComponenteEnum.EM_MANUTENCAO:
      return 'Em manutenção'
    case StatusComponenteEnum.AGUARDANDO_DESCARTE:
      return 'Aguardando descarte'
    case StatusComponenteEnum.DESCARTADO:
      return 'Descartado'
    default:
      return status
  }
}

export const EstadoComponenteEnum = {
  NOVO: 'novo',
  BOM: 'bom',
  REGULAR: 'regular',
  RUIM: 'ruim',
  DANIFICADO: 'danificado'
}

export function estadoComponenteText(estado) {
  switch (estado) {
    case EstadoComponenteEnum.NOVO:
      return 'Novo'
    case EstadoComponenteEnum.BOM:
      return 'Bom'
    case EstadoComponenteEnum.REGULAR:
      return 'Regular'
    case EstadoComponenteEnum.RUIM:
      return 'Ruim'
    case EstadoComponenteEnum.DANIFICADO:
      return 'Danificado'
    default:
      return estado
  }
}

class ComponenteService {
  async create(idContrato, idTipoComponente, qrCode, idModeloComponente, estado, quantidadeComponentes) {
    try {
      return await apiService.post(`componente`, { idContrato, idTipoComponente, qrCode, idModeloComponente, estado, quantidadeComponentes })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, idModeloComponente, estado) {
    try {
      return await apiService.put(`componente/${id}`, { idModeloComponente, estado })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async get(idContrato, idTipoComponente, idCruzamento, termo, status, pagina, paginar = true) {
    try {
      const qs = createQS({ idContrato, idCruzamento, idTipoComponente, termo, status, pagina, paginar })
      return await apiService.get(`componente?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get(`componente/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getHistorico(id) {
    try {
      return await apiService.get(`componente/${id}/historico`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getByCruzamento(idCruzamento) {
    try {
      return await apiService.get(`cruzamento/${idCruzamento}/componente`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarFilhos(idComponentePai) {
    try {
      return await apiService.get(`componente/${idComponentePai}/filhos`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async vincularFilho(idComponentePai, idComponenteFilho) {
    try {
      return await apiService.post(`componente-hierarquia`, { idComponentePai, idComponenteFilho })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async desvincularFilho(idComponenteFilho) {
    try {
      return await apiService.delete(`componente-hierarquia/${idComponenteFilho}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const componenteService = new ComponenteService()
export default componenteService